//import * as CryptoJS from 'crypto-js';
import VueJwtDecode from 'vue-jwt-decode';

export default {
    mixins: [],
    methods: {
        async mixinLogin(authData) {
            try {

                let result = await this.$axios.post(`${this.authServer}/signin`, authData);
                if (result.status === 200 && result.data.accessToken) {
                    localStorage.setItem("user-info", JSON.stringify(result.data));

                    //let userEmail = this.authServiceDecodeJwt().username;
                    //let profile = await this.findAgentByEmail(userEmail);

                    //localStorage.setItem('profile', JSON.stringify(profile));
                    if (this.isAdmin()){
                        window.location.href = "/"
                    }
                    // else if (this.isProfileFilled()){
                    //     window.location.href = "/feed"
                    // }
                    else {
                        window.location.href = "/feed-2"
                    }
                    //this.isProfileFilled() ? window.location.href = "/" : window.location.href = "/settings/personal-info";
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 403) {
                        this.$router.push({name: "AccountActivation"});
                    }
                }
            }
        },
        loggedIn() {
            return !!localStorage.getItem('user-info');
        },
        isAuthPages(componentName) {
            const authPages = ['SendSms','SignUp', 'Login', 'ResetPassword', 'AccountActivation', 'ForgotPassword'];
            return authPages.includes(componentName);
        },
        isPermitAll(componentName) {
            const permitAll = ['SmsDashboard','SmsBuyCredits', 'SmsWallet','VideoDetails', 'VideoList', 'UserFeed2', 'UserFeed3', 'UserMe','Configuration','NewMembers','Error', 'UserDashboard', 'UserFeed', 'DashboardOne',
                'Faqs', 'dashboard', 'ContactDashboardCard', 'UserFeed2'];
            return permitAll.includes(componentName);
        },
        hasPrivilege(componentName) {
            let decoded = this.authServiceDecodeJwt();
            return decoded.privileges.includes(componentName)
        },
        hasRole(role) {
            let decoded = this.authServiceDecodeJwt();
            return decoded.role.includes(role)
        },
        isAdmin() {
           return this.hasRole('ROLE_ADMIN');
        },
        authServiceDecodeJwt() {
            let userInfoData = localStorage.getItem('user-info');
            let encryptedToken = JSON.parse(userInfoData).accessToken;
            // let decodeBase64 = CryptoJS.enc.Base64.parse(encryptedToken);
            // let keyForCryptoJS = CryptoJS.enc.Base64.parse(process.env.VUE_APP_SECRET_KEY);
            // let decryptedData = CryptoJS.AES.decrypt({ciphertext: decodeBase64}, keyForCryptoJS, {
            //         mode: CryptoJS.mode.ECB,
            //         padding: CryptoJS.pad.Pkcs7
            //     }
            // );
            //var decrypted = CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8); // Message
            //return VueJwtDecode.decode(decryptedData.toString(CryptoJS.enc.Utf8));
            return VueJwtDecode.decode(encryptedToken);
        },
        userDetail() {
            let decoded = this.authServiceDecodeJwt();
            let profile = JSON.parse(localStorage.getItem('profile'));
            return {
                username: decoded.username,
                firstName: profile?.firstName === undefined ? decoded.firstName : profile?.firstName,
                lastName: profile?.lastName === undefined ? decoded.lastName : profile?.lastName,
                privileges: decoded.privileges,
                userId: decoded.userId,
                exp: decoded.exp,
                role: decoded.role,
                agentId: profile?.id
            }
        },
        loginTimeout() {
            let decoded = this.authServiceDecodeJwt();
            if (Date.now() > decoded.exp * 1000) {
                localStorage.clear();
                console.log('Please Sign Out,Token Expired')
                return true;
            }
        },
        isProfileFilled() {
            let agentNumber = JSON.parse(localStorage.getItem('profile')).agentNumber;
            return !!agentNumber;
        },
        // isBankInfoFilled() {
        //     let bankInfo = JSON.parse(localStorage.getItem('profile')).bankInfo;
        //     return !!bankInfo?.id;
        // },
        // isBusinessInfoFilled() {
        //     let businessInfo = JSON.parse(localStorage.getItem('profile')).businessInfo;
        //     return !!businessInfo?.id;
        // }
    }
};


// ,
// isDocumentsUploaded(){
//     let agentDocument = JSON.parse(localStorage.getItem('profile')).agentDocument;
//     return !!agentDocument?.id;
// }
// await new Promise(resolve => setTimeout(resolve, 3000));

